import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDaily } from '@daily-co/daily-react';
import { pageAtom, myNftAtom, displayNameAtom } from '../../State';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useConnect, useDisconnect, useAccount, useNetwork } from 'wagmi';
import { useTranslation } from 'react-i18next';
import DataModel from '../Util/DataModel';
import { isMobile } from 'react-device-detect';
import isElectron from '../../Global';
import { getImagePath } from '../Util/utils';
import { ReactComponent as TokenLockSVG } from '../Images/buttons/tokenLockButton.svg';

export default function LiveWalletConnect({
  liveData,
  roomID,
  setShowTokenGated,
  tokenGatedType,
  isPaid,
}) {
  //daily系
  const callObject = useDaily();
  const { t, i18n } = useTranslation();

  //Recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [displayNameState, setDisplayNameState] = useRecoilState(displayNameAtom);
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);

  //その他
  const [nftOwnArrayState, setNftOwnArrayState] = useState([]);
  const [loadingState, setLoadingState] = useState(false);
  const [noNFTExixt, setNoNFTExist] = useState(false);

  //wagmi
  const { address, isConnected } = useAccount();
  //const address = '0xD24db0BFb387b0ED05F757e5F3b9cA1C59a82605';
  const { connect, connectors } = useConnect();
  const { disconnect } = useDisconnect();
  // const { chains } = useNetwork();

  //表示するのを個々で切り替え
  var show1 = false;
  var show2 = false;

  if (typeof liveData.tokenGatedType !== undefined) {
    if (liveData.tokenGatedType == 'contractAddress' || liveData.tokenGatedType == 'collectionID') {
      show2 = true;
    } else {
      show1 = true;
    }
  } else {
    show1 = true;
  }

  //初回ロード時
  useEffect(() => {
    if (isElectron) {
      alert(
        t('live.Currently token-gated live is not supported in PC App. Please join from Browser'),
      );
      return;
    }

    //ウォレット接続中の場合
    if (isConnected) {
      getNFTListFromAddress();
    }
  }, []);

  //接続状況の監視
  useEffect(() => {
    if (isConnected && address != null) {
      getNFTListFromAddress();
    }
  }, [isConnected, address]);

  //ブラウザ用
  async function getNFTListFromAddress() {
    if (address != '' && address != null) {
      //ローディング中
      setLoadingState(true);

      //NFTリストを取得
      //var address2 = '0xe030EaDA1e2734356C4e170dCB8DA86B1F399482';
      //'0x4DB276B07389057cEB03A2EcA1C5bdB3F9927dFd'; testアドレス

      const result = await DataModel.getTokenGatedNFT(address, roomID, tokenGatedType);

      if (result) {
        setShowTokenGated(false);
        setNoNFTExist(false);
      } else {
        setNoNFTExist(true);
      }

      setLoadingState(false);
    }
  }

  //メタマスクの接続解除
  const tapDisconnect = async () => {
    var result = window.confirm(t('nft.Are you sure disconnect wallet?'));
    if (result) {
      setNoNFTExist(false);
      setNftOwnArrayState([]);
      disconnect();
    }
  };

  //購入ボタン
  const tapBuy = async () => {
    if (liveData != null) {
      if (liveData.ticketURL != null) {
        window.location.href = liveData.ticketURL;
      } else {
        window.location.href = 'https://faceless.third-webinar.com';
      }
    }
  };

  return (
    <>
      {loadingState ? (
        <div className="nft-main-loader" style={{ height: '120px' }}>
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path-gray"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#70c542"
                strokeWidth="2"
              />
            </svg>
          </div>
          <div id="loadingnow">{t('nft.Loading...')}</div>
        </div>
      ) : (
        <>
          {/* ウォレット接続がまだの場合 */}
          {isConnected == false ? (
            <>
              {show1 && <div id="nftNoExist">{t('live.To view this live, you need a NFT')} </div>}
              {show2 && (
                <div className="electronTokenOpenseaWrap2">
                  <div>
                    {liveData.collectionImageURL == null ? (
                      <TokenLockSVG />
                    ) : (
                      <img src={liveData.collectionImageURL} />
                    )}
                  </div>
                  <div className="electronTokenOpenseaDetail">
                    <div className="electronTokenOpenseaBody">
                      {t('mypage.Only holders can access')}
                    </div>

                    {liveData.ercType != null && liveData.ercType != 'ERC721'
                      ? liveData.contractAddress
                      : liveData.collectionName}
                  </div>
                </div>
              )}

              <div id="metamaskBox" style={{ padding: '0px', backgroundColor: 'transparent' }}>
                <div className="liveConnectTitle">{t('live.I have a NFT for this live')}:</div>
                <button
                  onClick={() => {
                    if (typeof window.ethereum !== 'undefined') {
                      connect({ connector: connectors[2] });
                    } else {
                      if (isMobile) {
                        alert(t('live.Please use MetaMask mobile app and access from browser'));
                      } else {
                        alert(t('live.Please install MetaMask extension in your browser'));
                      }
                    }
                  }}
                  className="loginButton">
                  <img src={getImagePath() + '/header/metaMask.svg'} />
                  <span> MetaMask</span>
                </button>

                {/* <button
                  onClick={() => {
                    connect({ connector: connectors[0] });
                  }}
                  className="loginButton">
                  <img src="./images/icons/coinbase.png" className="coinbase" />
                  <span> Coinbase Wallet</span>
                </button> */}

                <button
                  onClick={() => {
                    connect({ connector: connectors[1] });
                  }}
                  className="loginButton">
                  <img src={getImagePath() + '/icons/walletconnect.png'} />
                  <span> WalletConnect</span>
                </button>

                {isPaid && (
                  <>
                    <div className="liveConnectTitle">{t('live.I have no NFT')}:</div>
                    <div id="liveButton">
                      <button onClick={tapBuy}>{t('live.Buy NFT ticket now')}</button>
                    </div>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              {/* 対応しているNFTがない場合 */}
              {noNFTExixt ? (
                <>
                  {/* 対応しているNFTが存在しない */}
                  <div id="nftNoExist">{t('live.No NFT was found for this live')}</div>
                  <div className="disconnectMetamask" onClick={tapDisconnect}>
                    {t('nft.disconnect')}
                  </div>

                  {isPaid && (
                    <div id="liveButton">
                      <button onClick={tapBuy}>{t('live.Buy NFT ticket now')}</button>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="disconnectMetamask" onClick={tapDisconnect}>
                    {t('nft.disconnect')}
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
